export default __webpack_public_path__ + "static/media/pluma-splash.1ab6fbec.png";